import axios from 'axios';

export default async (
  restaurantId: string,
  tableNumber: string,
  paymentMode: boolean
): Promise<{ clientId: string }> => {
  const path = paymentMode
    ? `/v2/restaurants/${restaurantId}/payment/tables/${tableNumber}`
    : `/v2/restaurants/${restaurantId}/tables/${tableNumber}`;
  const { data } = await axios.post(`${window.AZZURRI_ENV.apiEndpoint}${path}`);
  return data;
};
